export default "__VITE_ASSET__DTGf5MgM__"